module.exports = __webpack_public_path__ + "static/img/banner_social.07406fab.png";